/*
// Lazy Image
(function() {
class ImageSrcSet extends HTMLElement {
  get intersecting() {
    return this.hasAttribute('intersecting');
  }  
  constructor() {
    super();
    this.img = this.querySelectorAll('img');
    this.observerCallback = this.observerCallback.bind(this);
    this.loadImage = this.loadImage.bind(this);
    this.img.forEach(item => item.onload = this.onLoad.bind(this))
  }
  connectedCallback() {
    if ('IntersectionObserver' in window) this.initIntersectionObserver();else this.loadImage();
  }
  disconnectedCallback() {
    this.disconnectObserver();
  }
  loadImage() {
    this.setAttribute('intersecting', 'true');
    this.img.forEach(item => {
        item.width = this.clientWidth;
        item.height = this.clientHeight;
        item.sizes = this.clientWidth + 'px';
    })
    this.img.forEach(item => {
        item.classList.add('res-img-loaded');
    })
  }
  onLoad() {
    this.removeAttribute('data-image-loading');
  }
  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadImage();
  }
  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = '10px';
    this.observer = new IntersectionObserver(this.observerCallback, {
      rootMargin
    });
    this.observer.observe(this);
  }
  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}
customElements.define('image-srcset', ImageSrcSet);
})();


  document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname === '/' || document.querySelector('.sections-featured-collection, [id*="featured-collection"]')) {
    
    const updateImgAlt = (img) => {
      const oldAlt = img.getAttribute('alt');
      if (oldAlt && oldAlt.includes('| Allegory Ink') && !oldAlt.includes('Featured collection')) {
        img.setAttribute('alt', oldAlt.replace('| Allegory Ink', '| Featured collection Allegory Ink'));
      }
    };

    document.querySelectorAll('img.res-img-loaded').forEach(updateImgAlt);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.tagName === 'IMG' && target.classList.contains('res-img-loaded')) {
            updateImgAlt(target);
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }
});
*/


// Lazy Image + Dynamic Alt Updater
(function() {
class ImageSrcSet extends HTMLElement {
  get intersecting() {
    return this.hasAttribute('intersecting');
  }  
  constructor() {
    super();
    this.img = this.querySelectorAll('img');
    this.observerCallback = this.observerCallback.bind(this);
    this.loadImage = this.loadImage.bind(this);
    this.img.forEach(item => item.onload = this.onLoad.bind(this))
  }
  
  connectedCallback() {
    this.img.forEach(item => this.updateCustomAlt(item));

    if ('IntersectionObserver' in window) {
      this.initIntersectionObserver();
    } else {
      this.loadImage();
    }
  }
  
  disconnectedCallback() {
    this.disconnectObserver();
  }
  
  updateCustomAlt(item) {
    const oldAlt = item.getAttribute('alt');
    const hasRequiredParent = item.closest('.image-inner.position-relative.overflow-hidden');

    if (oldAlt && oldAlt.includes('| Allegory Ink') && !oldAlt.includes('Featured collection') && hasRequiredParent) {
      item.setAttribute('alt', oldAlt.replace('| Allegory Ink', '| Featured collection Allegory Ink'));
    }
  }

  loadImage() {
    this.setAttribute('intersecting', 'true');
    this.img.forEach(item => {
        item.width = this.clientWidth;
        item.height = this.clientHeight;
        item.sizes = this.clientWidth + 'px';
        
        this.updateCustomAlt(item);
    })
    this.img.forEach(item => {
        item.classList.add('res-img-loaded');
    })
  }
  
  onLoad() {
    this.removeAttribute('data-image-loading');
    this.img.forEach(item => this.updateCustomAlt(item));
  }
  
  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadImage();
  }
  
  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = '10px';
    this.observer = new IntersectionObserver(this.observerCallback, {
      rootMargin
    });
    this.observer.observe(this);
  }
  
  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}

if (!customElements.get('image-srcset')) {
  customElements.define('image-srcset', ImageSrcSet);
}
})();